import script from "./dishOrderScanView.vue?vue&type=script&setup=true&lang=js"
export * from "./dishOrderScanView.vue?vue&type=script&setup=true&lang=js"

import "./dishOrderScanView.vue?vue&type=style&index=0&id=1120ca74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1120ca74"]])

export default __exports__